/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import React, { useEffect, useRef, useState } from 'react';
import { Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../redux/hooks/redux';
import { getGtmAndGaAccounts, setGoogleCredentials } from '../../redux/actions/Google';
import { GOOGLE_ACCOUNT_SCOPES } from '../../constant/Google';
import clsx from 'clsx';
import { jwtDecode } from 'jwt-decode';

const GoogleLoginButton = () => {
  const [oneTapListener, setOneTapListener] = useState<google.accounts.id.PromptMomentNotification>()

  const dispatch = useAppDispatch();
  const profile = useAppSelector((state) => state.google.profile);
  const clientId = useAppSelector((state) => state.systemProperties.googleClientId);

  const oauth2 = useRef<google.accounts.oauth2.TokenClient>();

  const tokenCallback = token => {
    dispatch(setGoogleCredentials({ token }));
    dispatch(getGtmAndGaAccounts());

    // auto refresh token
    setTimeout(() => oauth2.current.requestAccessToken(), token.expires_in * 1000);
  };

  const oauthCallback = (oauth) => {
    if (!oauth.credential) {
      return;
    }

    const profile: any = jwtDecode(oauth.credential);

    dispatch(setGoogleCredentials({ profile }));

    oauth2.current = google.accounts.oauth2.initTokenClient({
      client_id: clientId,
      callback: tokenCallback,
      scope: GOOGLE_ACCOUNT_SCOPES,
      hint: profile.email,
      prompt: 'none'
    });

    oauth2.current.requestAccessToken();
  };

  useEffect(() => {
    // Set client for silent log in
    if (clientId) {
      google.accounts.id.initialize({
        client_id: clientId,
        callback: oauthCallback,
        prompt_parent_id: 'oneTap',
        auto_select: true
      });

      google.accounts.id.prompt(lis => {
        setOneTapListener(lis);
      });

      google.accounts.id.renderButton(
        document.getElementById('buttonDiv'),
        { type: 'icon', theme: 'outline', size: 'large' }  // customization attributes
      );
    }
  }, [clientId]);

  const isOneTapDisplayed = oneTapListener ? oneTapListener.isDisplayed() : true

  return (
    <div id="oneTap">
      <div className={clsx('centeredFlex', isOneTapDisplayed && 'd-none')}>
        <Typography variant="caption" color="textSecondary" marginRight={1}>
          {profile ? `Logged into Google as ${profile.email}` : 'Login to connect your sites with google services'}
        </Typography>
        <div id="buttonDiv"/>
      </div>
    </div>
  );
};

export default GoogleLoginButton;